const getFileExtension = (fileName: string) => {
  return fileName.split('.').pop()
}
export default getFileExtension
